import { CandidateRankingModel } from 'config/common/baseModel'
import { BotulismGuidelineModel as _BotulismGuidelineModel } from 'config/common/baseModel/Guideline'
import { SortOrders } from 'enums/SortOrders'
import {
  compose,
  renameColumn,
  updateColumnAttributes,
  whiteListColumn,
} from 'utils/overrideModel'

export const BotulismGuidelineModel = compose<typeof _BotulismGuidelineModel>(
  whiteListColumn([
    'area',
    'disease',
    'isNationalNotifiableDisease',
    'authorities',
    'diagnosisApproach',
    'interventionAvailability',
    'candidates',
    'interventionType',
    'accessProtocol',
    'interventionTiming',
    'labs',
    'notes',
    'bioterrorismConsideredNotes',
    'source',
    'lastUpdated',
  ])
)({ ..._BotulismGuidelineModel, name: 'Botulism Guidelines' })

export const BotulismCandidateModel = compose<typeof CandidateRankingModel>(
  whiteListColumn([
    'candidateName',
    'latestPhaseManual',
    'sponsors',
    'alternativeNames',
    'diseaseName',
    'pathogenTypes',
    'designationB',
    'routeOfAdministration',
    'type',
    'subType',
    'vaccineAdjuvants',
    'targetPopulation',
    'vaccineValency',
    'targetViralStrain',
    'frontendNotes',
    'latestPhaseManualSource',
  ]),
  renameColumn('latestPhaseManualSource', 'Source'),
  updateColumnAttributes('latestPhaseManual', {
    sortOrderObject: [
      'Approved',
      'Phase III',
      'Phase II/III',
      'Phase II',
      'Phase I/II',
      'Phase I',
      'Preclinical',
    ],
  })
)({
  ...CandidateRankingModel,
  defaultSortObject: [
    {
      id: 'latestPhaseManual',
      sortOrder: SortOrders.ASC,
    },
  ],
})
